import { createApp } from 'vue';
import App from './App.vue';
import router, { lenis } from './router';
import i18n from './i18n';

const app = createApp(App);

app.use(router).use(i18n).mount('#app');
app.config.globalProperties.$lenis = lenis;
